// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import SignatureActionType from './signature.types';

const INITIAL_STATE = {
	// Upload Signature
	uploadSignature: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** upload Signature Start ************************/
		case SignatureActionType.UPLOAD_SIGNATURE_SUCCESS:
			return { ...state, uploadSignature: action.payload };

		case SignatureActionType.UPLOAD_SIGNATURE_FAILURE:
			return { ...state, uploadSignature: action.payload };

		case SignatureActionType.UPLOAD_SIGNATURE_RESPONSE_CHANGED:
			return { ...state, uploadSignature: null, uploadSignatureStatus: null };

		/** ***************** upload Signature End ************************/
		default:
			return state;
	}
};
